// Welle 8c-pre47 (F5-Restore): Persistiert den aktiven Call-Kontext des Beraters, damit
// ein Reload (F5) den laufenden Call automatisch wieder aufnimmt, statt ihn abzureißen.
//
// sessionStorage ist bewusst gewählt: Der Kontext überlebt Reload/Navigation innerhalb
// desselben Tabs, wird aber beim Schließen des Tabs geleert. Ein bewusst geschlossener
// Tab beendet den Call also — nur ein Reload nimmt ihn wieder auf. Ein TTL begrenzt die
// Wiederaufnahme zusätzlich auf kurze Reloads; nach langer Abwesenheit (Stele-byeGrace
// längst abgelaufen) wird der gespeicherte Kontext verworfen.

const KEY = 'bamoa_active_call';
const TTL_MS = 5 * 60 * 1000; // 5 min — deckt Reloads ab, nicht lange Abwesenheit

export interface PersistedCall {
  callId: string;
  rtcToken: string;
  /** Anzeigedaten aus call:incoming (steleName, tenantName, group, …), für die UI nach Reload. */
  incoming: unknown | null;
  savedAt: number;
}

export function saveCallSession(data: Omit<PersistedCall, 'savedAt'>): void {
  try {
    if (!data.callId || !data.rtcToken) return;
    const rec: PersistedCall = { ...data, savedAt: Date.now() };
    sessionStorage.setItem(KEY, JSON.stringify(rec));
  } catch { /* ignore */ }
}

export function loadCallSession(): PersistedCall | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const rec = JSON.parse(raw) as PersistedCall;
    if (!rec?.callId || !rec?.rtcToken) return null;
    if (Date.now() - (rec.savedAt ?? 0) > TTL_MS) { clearCallSession(); return null; }
    return rec;
  } catch {
    return null;
  }
}

export function clearCallSession(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}

/** Default an; Rückfall über ?f5restore=0 (deaktiviert die automatische Wiederaufnahme). */
export function f5RestoreEnabled(): boolean {
  try { return new URL(window.location.href).searchParams.get('f5restore') !== '0'; } catch { return true; }
}
